import axios from "axios";
import store from '@/store/index'

import { AD_API_URL } from "@/common/config";
import AuthService from "@/services/azure_active_directory/auth";

function init() {
    const instance = axios.create({
        baseURL: AD_API_URL,
        //timeout: 10000
    });

    instance.defaults.headers.common['SdkVersion'] = 'postman-graph/v1.0';

    const token = store.state.auth.token;
    if(token)
        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    return instance;
}

const Api = {
    get(resource, params = null) {
        return init().get(resource, params)
    },
    post(resource, postDatas, params = null) {
        return init().post(resource, postDatas, params);
    },
};

export default Api;